/* eslint-disable react/require-default-props */

import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { extend, QueryProvider, QueryContext } from '@thd-nucleus/data-sources';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { useBundleMiniFbtLayout } from '../hooks/useBundleMiniFbtLayout';
import { isProductAvailable, shouldDisplayConfigurator } from '../utils/product-utils';
import { BundleMini } from './BundleMini';
import { useBundle } from '../hooks/useBundle';
import { BundleFbt } from '../subcomponents/BundleFbt';
import { BundleMiniContextProvider } from '../context/BundleMiniContext';

const BundlePmvFbtLayoutB2bGm = ({ itemId = '', name = '' }) => {
  const { productData, isServer } = useBundleMiniFbtLayout({ itemId });
  const displayConfigurator = shouldDisplayConfigurator(productData, isServer);
  const { defaultVariables } = useContext(QueryContext);
  const ctx = useContext(ExperienceContext);
  const isB2BCustomer = ctx?.customer?.type === 'b2b';
  const abcTestEnable = useConfigService('fs:isABCTestEnable');

  const { bundleIds } = useBundle({ product: productData?.product });

  if (!productData || displayConfigurator) {
    return null;
  }

  const { product } = productData || {};
  const availableProduct = isProductAvailable(product, abcTestEnable);

  if (!availableProduct || !isB2BCustomer) {
    return null;
  }

  // IF new BIP parent bundle is presented, show BIP BEC
  if (bundleIds) {
    return (
      <BundleMiniContextProvider itemId={itemId}>
        <QueryProvider
          cacheKey="bundle-mini-provider"
          defaultVariables={defaultVariables.current}
        >
          <BundleMini bundleIds={bundleIds} />
        </QueryProvider>
      </BundleMiniContextProvider>
    );
  }

  // ELSE IF BIP parent bundle is not present then FBT is applicable, show FBT
  return (
    <BundleFbt
      itemId={itemId}
      name={name}
    />
  );
  // ELSE show nothing (already handled by null returns above)
};

BundlePmvFbtLayoutB2bGm.propTypes = {
  itemId: string,
  name: string
};

BundlePmvFbtLayoutB2bGm.dataModel = extend(
  BundleMini,
  BundleFbt
);

BundlePmvFbtLayoutB2bGm.displayName = 'BundlePmvFbtLayoutB2bGm';

export { BundlePmvFbtLayoutB2bGm };